module.exports = __webpack_public_path__ + "img/34.149e7a37.jpg";